import { Injectable, ComponentRef } from '@angular/core';
import { WindowShellComponent } from '../components/window-shell/window-shell.component';

@Injectable()

export class WindowManager {

  public activeWindows: ComponentRef<WindowShellComponent>[] = [];

  constructor() {}

  public get quantity() {
    return this.activeWindows.length;
  }
}
